import _extends from 'babel-runtime/helpers/extends';
import _Promise from 'babel-runtime/core-js/promise';
import injected from '../injected';
import { instance as axios } from './instance';
import get from 'lodash/get';

export default (function (method, endpoint, body, settings) {
  var url = '' + injected.BACKEND_URL + endpoint;
  /*
    We need to append the source to the url in order to differentiate the request made
    by the chrome-extension from the one made by the homebase.
    We need to differentiate them to avoid having requests sent by the extension (which doesn't have the proper CORS headers)
    used in the homebase. It might happen because of the cache used by the browser. Indeed when we are on a random page
    where the extension is active and we go back to the previous page (the homebase) a request is sent both by the extension and
    the homebase. Since the browser caches the response, and when the requests are the same, it uses the response from
    the extension to serve the request made by the homebase which triggers CORS issue.
  */
  var isQuestionMarkPresent = url && url.indexOf('?') !== -1;
  var separator = isQuestionMarkPresent ? '&' : '?';

  url += separator + 'source=' + injected.source;

  return new _Promise(function (resolve, reject) {
    var request = _extends({
      method: method,
      url: url,
      withCredentials: true
    }, settings);
    if (body) {
      request.data = body;
    }

    axios(request).then(function (res) {
      resolve(res.data);
    }).catch(function (err) {
      var response = get(err, 'response');
      var message = get(err, 'message') ? { message: err.message } : undefined;
      var error = { error: err, method: method, endpoint: endpoint };
      reject(response || message || error);
    });
  });
});
//# sourceMappingURL=request.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/utils/request.js
// module id = 484
// module chunks = 0